import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import AuthenticationService from '../_services/AuthenticationService';

// Never record a public page as the post-login return target — sending the
// user "back" to /unauthorized after they sign in would show a stale
// "You are not signed in" screen. Mirrors PUBLIC_PATHS in routes/index.tsx.
const PUBLIC_PATHS = ['/login', '/forgot-password', '/unauthorized'];
const isPublicPath = (path: string) =>
  PUBLIC_PATHS.some((p) => path === p || path.startsWith(`${p}/`) || path.startsWith(`${p}?`));

const SessionExpiredModal: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const showRef = useRef(false);
  const locationRef = useRef(location);
  const returnPathRef = useRef('/home');

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  useEffect(() => {
    const handler = () => {
      if (showRef.current) return;
      const currentPath = locationRef.current.pathname + locationRef.current.search;
      if (currentPath && !isPublicPath(currentPath)) {
        returnPathRef.current = currentPath;
      }
      showRef.current = true;
      setShow(true);
    };
    window.addEventListener('iteach:session-expired', handler);
    return () => window.removeEventListener('iteach:session-expired', handler);
  }, []);

  const handleLogin = () => {
    setShow(false);
    showRef.current = false;
    AuthenticationService.logout();
    const next = encodeURIComponent(returnPathRef.current);
    history.push(`/login?next=${next}`);
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Session Expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Your session has expired. Please log in again to continue.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleLogin}>
          Log in
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionExpiredModal;
